export const homeObjOne = {
	id: "introduction",
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: "introduction",
	headline: "Our mission",
	description:
		"Improve the quality of life of people with disabilities and strive to realize the full potential of every person with disabilities, using available resources in the community.",
	buttonLabel: "Get started",
	imgStart: false,
	img: require("../../images/strip.jpeg").default,
	alt: "Image",
	dark: true,
	primary: true,
	darkText: false,
};

export const homeObjTwo = {
	id: "conclusion",
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: "about us",
	headline: "Caps for handicap story",
	description:
		"All Caps for Handicaps is focused on raising awareness and promoting the culture of recycling all sorts of plastic caps in our community to raise money towards helping the handicapped.",
	buttonLabel: "Get started",
	imgStart: true,
	img: require("../../images/svg-1.svg").default,
	alt: "Image",
	dark: true,
	primary: true,
	darkText: false,
};
